/**
 * 智能客服：店铺飞鸽掉登弹窗提醒（可多店合并）
 */
import { MessageBox } from "element-ui";

/** @type {Map<string, string>} */
const pending = new Map();
/** @type {Record<string, number>} */
const alertedAt = Object.create(null);
let flushTimer = null;
/** 同一店铺冷却，避免轮询反复弹 */
const COOLDOWN_MS = 15 * 60 * 1000;
const FLUSH_MS = 700;

export function isKefuShopAuthFail(status, errorMsg) {
  if (String(status || "") !== "error") return false;
  const msg = String(errorMsg || "");
  return /掉登|登录过期|登录|未登录|重新登录|需登录|login|auth|StatusCode_4|status_code[=:\s]*4\b/i.test(
    msg
  );
}

function flushAuthFailAlert() {
  flushTimer = null;
  if (!pending.size) return;
  const entries = Array.from(pending.entries());
  pending.clear();
  const now = Date.now();
  const lines = [];
  for (let i = 0; i < entries.length; i++) {
    const [id, name] = entries[i];
    alertedAt[id] = now;
    lines.push(`${i + 1}. ${name || "店铺" + id}`);
  }
  const body =
    entries.length === 1
      ? `店铺「${entries[0][1]}」飞鸽登录已失效（掉登），请重新登录该店铺后，在智能回复页点「刷新店铺」。`
      : `以下 ${entries.length} 家店铺飞鸽登录已失效（掉登），请重新登录后，在智能回复页点「刷新店铺」：\n\n${lines.join(
          "\n"
        )}`;
  try {
    MessageBox.alert(body, "店铺掉登提醒", {
      type: "warning",
      confirmButtonText: "知道了",
      dangerouslyUseHTMLString: false,
      customClass: "kefu-shop-auth-fail-alert",
    }).catch(() => {});
  } catch (e) {}
}

/**
 * 店铺从非掉登 → 掉登时调用；短时间多店合并成一次弹窗
 */
export function notifyKefuShopAuthFail(payload) {
  if (!payload) return;
  const shopId = String(payload.shopId || "").trim();
  if (!shopId) return;
  if (!isKefuShopAuthFail(payload.status, payload.errorMsg)) return;
  const now = Date.now();
  if (alertedAt[shopId] && now - alertedAt[shopId] < COOLDOWN_MS) return;
  const name =
    String(payload.shopName || "").trim() ||
    `店铺 ${shopId}`;
  pending.set(shopId, name);
  if (flushTimer) clearTimeout(flushTimer);
  flushTimer = setTimeout(flushAuthFailAlert, FLUSH_MS);
}

/** 恢复在线后允许再次提醒 */
export function clearKefuShopAuthFailCooldown(shopId) {
  const id = String(shopId || "").trim();
  if (!id) return;
  delete alertedAt[id];
  pending.delete(id);
}
